import type { StorageKey } from '@core/interfaces/IStorage';

export const getStorageKeys: () => StorageKey[] = () => [
  'active-lang',
  'ador-backup-path',
  'alert-config',
  'announcement-record',
  'auto-save-config',
  'auto_check_update',
  'auto_connect',
  'beambox-preference',
  'black-list',
  'customizedLaserConfigs',
  'default-font',
  'default-params-label-keys',
  'default-units',
  'defaultLaserConfigsInUse',
  'did-gesture-tutorial',
  'elements-history',
  'enable-sentry',
  'flux-rsa-key',
  'font-history',
  'font-name-map',
  'guessing_poke',
  'keep-flux-id-login',
  'last-installed-version',
  'last-promark-serial',
  'last-record-activity',
  'layer-color-config',
  'layer-panel-height',
  'loop_compensation',
  'maintenance-records',
  'new-user',
  'notification',
  'poke-ip-addr',
  'presets',
  'printer-is-ready',
  'promark-store',
  'questionnaire-version',
  'rating-record',
  'recent_files',
  'registered-devices',
  'selected-device',
  'sentry-send-devices',
];
